import { useCallback, useState } from 'react';

/**
 * Hook that manages popover anchor element state
 * @param startingAnchor Initial anchor element (defaults to null)
 * @returns Tuple containing [anchor, open, close]
 */
export const usePopoverAnchor = <T = HTMLElement | null>(
  startingAnchor: T = null as T
): [T, (anchor: T) => void, () => void] => {
  const [anchor, setAnchor] = useState<T>(startingAnchor);

  const open = useCallback((a: T): void => {
    setAnchor(a);
  }, []);

  const close = useCallback((): void => {
    setAnchor(null as T);
  }, []);

  return [anchor, open, close];
};
